import "core-js/stable";
import "regenerator-runtime/runtime";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import VueWechatTitle from "vue-wechat-title";
import store from "./store";
import "./utils/rem";
// Toast
import {
  Toast,
  Dialog,
  List,
  NumberKeyboard,
  Swipe,
  SwipeItem,
  Switch,
  Tab,
  Tabs,
  Progress,
  Button,
  Field,
} from "vant";
import "vant/lib/index.css";
// import VConsole from "vconsole";
// new VConsole();

const app = createApp(App);
app
  .use(router)
  .use(VueWechatTitle)
  .use(store)
  .use(List)
  .use(NumberKeyboard)
  .use(Swipe)
  .use(SwipeItem)
  .use(Switch)
  .use(Tab)
  .use(Tabs)
  .use(Progress)
  .use(Button)
  .use(Field)
  .use(Toast)
  .use(Dialog)
  .mount("#app");
